/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-06-29 10:46:50
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseStringToArray } from '../utils';
import classnames from 'classnames';
import { cloneDeep } from 'lodash';
import { getVisual } from '../../../controller';

const defaultValue = '梅赛德斯奔驰\t361,242,329 DB\t\n特斯拉\t378,437,438 DB\t\n勃林格殷格翰\t413,958,381 DB\t\n西门子\t1,276,640,541 DB\t\n迪卡侬\t396,192,412 DB\t\n欧莱雅\t657,778,128 DB\t\n精工爱普生\t495,559,468 DB \t\n蒂森克虏伯 \t518,691,805 DB\t\n霍尼韦尔\t403,247,998 DB\t\n';
const defaultColorValue = '#997300\n#626262\n#9e480e\n#5b9bd5\n#6096e6\n#254274\n#ed7d31\n#ffc000\n#a5a5a5\n#6ca845\n';

class Form extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      colorValue: defaultColorValue,
      dataset: [],
      chartTitle: [],
      chartList: [],
      tableColorList: [],
      chartColorList: [],
    }
  }

  componentDidMount() {
    this.loadData();
  }

  
  loadData = () => {
    const { onChange } = this.props;

    getVisual(3).then(value => {
      const _table = Form.parse(value);
      const _tempColor = Form.parseColor(defaultColorValue);

      this.setState({
        value: value,
        ..._table,
        ..._tempColor
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._tempColor
      });
    });
  }

  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;
    const { chartTitle, chartList } = Form.parseChart(cloneDeep(dataset));

    return {
      dataset,
      chartTitle,
      chartList,
    }
  }

  static parseChart = (arr) => {
    const chartList = arr.map(([name = '', value = '']) => ({
      name,
      value: Number(value.replace(/[^(\d|\.)]/g, '')),
    }));

    return { chartList }
  }

  static parseColor = (str) => {
    const chartColorList = str.split(/\n/).filter(Boolean).map(item => item.trim());

    return { chartColorList }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = Form.parse(value);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const _color = Form.parseColor(value);

    this.setState({
      colorValue: value,
      ..._color,
    })

    typeof onChange === 'function' && onChange(_color)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
        <div>颜色设置（颜色只和顺序有关）</div>
        <textarea className={classnames(s.inputText)} value={this.state.colorValue} onChange={this.onChangeColor} />
      </div>
    );
  }
}

export default withStyles(s)(Form);



// WEBPACK FOOTER //
// src/routes/visualChart/P3/Form.js